<template>
  <div>
    <el-form
      :inline="true"
      :model="queryParam"
      class="demo-form-inline"
      size="mini"
    >
      <el-form-item label="订单时间 ：">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="queryParam.beginTime"
            style="width: 100%;"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-col>
        <el-col class="line" style="text-align:center;" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="queryParam.endTime"
            style="width: 100%;"
            value-format="yyyy-MM-dd 23:59:59"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="订单号 ：">
        <el-input v-model="queryParam.orderSn" placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item label="ISBN ：">
        <el-input v-model="queryParam.isbn" placeholder="ISBN"></el-input>
      </el-form-item>
      <el-form-item label="收件人 ：">
        <el-input v-model="queryParam.consignee" placeholder="收件人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话 ：">
        <el-input v-model="queryParam.tel" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="有备注 ：" style="margin: 0 40px;">
        <el-checkbox v-model="queryParam.haveRemarkFlag">有</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
        <el-button type="success" @click="exportExcels" icon="el-icon-download">导出</el-button>
        <el-button type="success" @click="onOpenOrder" icon="el-icon-download">一键展开</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="进行中订单" name="1"
        ><order-on  ref="orderOn" @selectionChange="selectionChange"></order-on
      ></el-tab-pane>
      <el-tab-pane label="已完成订单" name="2"
        ><order-complete
          ref="orderComplete" @selectionChange="selectionChange"
        ></order-complete
      ></el-tab-pane>
      <el-tab-pane label="待付款订单" name="3"
        ><order-no-pay
          ref="orderNoPay" @selectionChange="selectionChange"
        ></order-no-pay>
      </el-tab-pane>
      <el-tab-pane label="已取消订单" name="4"
        ><order-cancel
          ref="orderCancel" @selectionChange="selectionChange"
        ></order-cancel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { downFile } from "../../api/index";
import orderOn from "./myorder/orderOn";
import orderNoPay from "./myorder/orderNoPay";
import orderComplete from "./myorder/orderComplete";
import orderCancel from "./myorder/orderCancel";
export default {
  name: "orderMain",
  provide() {
    return {
      parentQueryParam: this.queryParam
    }
  },
  data() {
    return {
      tableData: [],
      textarea: "",
      ids: "",
      orderId: "",
      activeName: "1",
      isdefault: false,
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      url: {
        getorderLit: "/order/queryList",
        exportExcel: "/order/exportExcel",
        exportExcels: "/order/exportExcels",
      },
      expandAllOrder: false,
    };
  },
  components: {
    orderOn,
    orderNoPay,
    orderComplete,
    orderCancel,
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    console.log("this.$route.params :>> ", this.$route.params);
    this.activeName = this.$route.params.flag;
  },
  methods: {
    onOpenOrder(){ // 展开所用订单
      var f = !this.expandAllOrder;
      if (this.activeName === "1") {
        this.$refs.orderOn.onOpenOrderRowInfo(f);
      }else if (this.activeName === "2") {
      console.log('active=2', f)
        // this.$refs.orderComplete.onOpenOrderRowInfo(f);
      }else if (this.activeName === "3") {
      console.log('active=3', f)
        this.$refs.orderNoPay.onOpenOrderRowInfo(f);
      }else if (this.activeName === "4") {
        // this.$refs.orderCancel.onOpenOrderRowInfo(f);
      }
    },
    handleClick() {
      let isbn = this.queryParam.isbn;
      let orderSn = this.queryParam.orderSn;
      let createTime_begin = this.queryParam.beginTime;
      let createTime_end = this.queryParam.endTime;
      let consignee = this.queryParam.consignee;
      let tel = this.queryParam.tel;
      let haveRemarkFlag = this.queryParam.haveRemarkFlag;
      if (this.activeName === "1" && this.$refs.orderOn.getOrderList) {
        this.$refs.orderOn.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }else if (this.activeName === "2" && this.$refs.orderComplete.getOrderList) {
        this.$refs.orderComplete.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }else if (this.activeName === "3" && this.$refs.orderNoPay.getOrderList) {
        this.$refs.orderNoPay.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }else if (this.activeName === "4" && this.$refs.orderCancel.getOrderList) {
        this.$refs.orderCancel.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }
    },
    onSubmit() {
      let isbn = this.queryParam.isbn;
      let orderSn = this.queryParam.orderSn;
      let createTime_begin = this.queryParam.beginTime;
      let createTime_end = this.queryParam.endTime;
      let consignee = this.queryParam.consignee;
      let tel = this.queryParam.tel;
      let haveRemarkFlag = this.queryParam.haveRemarkFlag;
      console.log("createTime_end=============", createTime_end);
      if (this.activeName === "1") {
        this.$refs.orderOn.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
      if (this.activeName === "2") {
        this.$refs.orderComplete.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
      if (this.activeName === "3") {
        this.$refs.orderNoPay.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
      if (this.activeName === "4") {
        this.$refs.orderCancel.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
    },
    selectionChange(data){
      this.ids="";
      if (data.length>0) {
          for (var i = 0; i < data.length; i++) {
              this.ids = this.ids + data[i].orderSn + ","
          }
      }
    },
    exportExcels() {
      let fileName = "京麦通订单";
      if (this.ids!=""){
        this.orderId=this.ids
      }else {
        this.orderId=this.queryParam.orderSn
      }
      downFile(this.url.exportExcels, {
        userId: this.$store.state.userInfo.id,
        isbn : this.queryParam.isbn,
        orderSn : this.orderId,
        createTime_begin : this.queryParam.beginTime,
        createTime_end : this.queryParam.endTime,
        consignee: this.queryParam.consignee,
        tel: this.queryParam.tel,
        haveRemarkFlag: this.queryParam.haveRemarkFlag,
      }).then((data) => {
        console.log("data :>> ", data);
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }

        // 保留原文件名
        const contentDisposition = data.headers['content-disposition'];
        if (contentDisposition) {
          let fileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
          if (!fileNameMatch) {
            fileNameMatch = contentDisposition.match(/filename="?([^;"\n]+)"?/i);
          }
          if (fileNameMatch.length > 1) {
            fileName = fileNameMatch[1];
            // 如果有编码格式（比如UTF-8），需要解码
            if (fileName.startsWith("UTF-8''")) {
              fileName = decodeURIComponent(fileName.replace("UTF-8''", ""));
            } else {
              fileName = decodeURIComponent(fileName);
            }
          }
        } else { 
          fileName += ".xls";
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
                  new Blob([data.data], { type: "application/vnd.ms-excel" }),
                  fileName
          );
        } else {
          let url = window.URL.createObjectURL(
                  new Blob([data.data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },

    exportExcel() {
      let fileName = "京麦通订单";
      downFile(this.url.exportExcel, {
        userId: this.$store.state.userInfo.id,
      }).then((data) => {
        console.log("data :>> ", data);
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data.data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-cascader {
  display: block;
}
</style>
